/** Friendly full-card empty state for when a tenant hasn't been assigned a
 *  network and/or WiFi yet — a normal pre-provisioning state, not an error.
 *  Big, clear copy plus a deep link into the contact form with the request
 *  pre-filled, so the member can ask to get set up in one tap. Moved from
 *  `pages/network.tsx` when the page split into tabs (#310). */
import { Link } from "react-router-dom";
import { WifiOff } from "lucide-react";
import { Button, Card, Stack, Text, Title } from "@mantine/core";
import { supportLink } from "./shared";

export function NotAssigned({
  title,
  body,
  subject,
  message,
}: {
  title: string;
  body: string;
  subject: string;
  message: string;
}) {
  return (
    <Card withBorder padding="xl">
      <Stack align="center" gap="md" py="xl">
        <WifiOff size={48} style={{ color: "var(--mantine-color-dimmed)" }} />
        <Title order={3} ta="center">{title}</Title>
        <Text fz="lg" c="dimmed" ta="center" maw={460}>{body}</Text>
        <Button component={Link} to={supportLink(subject, message)} size="md" mt="xs">
          Contact support
        </Button>
      </Stack>
    </Card>
  );
}
